import { makeStyles } from '@material-ui/styles'

const useStyles = makeStyles(theme => ({
  root: {
    '& span.title': {
      //marginLeft: 15
      textTransform: 'uppercase'
    },
    '& .btn': {
      padding: '0px 15px 0px 0px'
    },
    '& button.go-back-button': {
      border: theme.card.border
    },
    '& .btn-link': {
      color: 'inherit'
    },
    '& .MuiSvgIcon-root': {
      fill: theme.palette.text.primary
    }
  },
  pageIcon: {
    marginLeft: theme.spacing(1)
  },
  loading: {
    position: 'relative',
    width: 25,
    top: 2,
    left: 3
  },
  buttons: {
    display: 'inline-block',
    float: 'right'
  },
  collapse: {
    marginLeft: `${theme.spacing(2)}px !important`,
    minWidth: 'inherit',
    paddingLeft: '25px'
  }
}))

export {
  useStyles
}
